import { Api } from '../../../../../utility/client';

export const confirmPhoneNumber = async (confirmationCode: string) => {
  const res = await Api.post<void>(
    `/v1/user/mobilePhone/confirm/${confirmationCode}`,
  );

  return res.data;
};
